import styled from "styled-components/macro";

export const SelectedStyleLabel = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  margin-left: 20px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  cursor: pointer;
  gap: 10px;

  .selected-style-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--grey-1);
    font-size: 16px;
    font-weight: 400;
    line-height: 1.2;
  }


  &:focus-visible {
    outline: 2px solid var(--primary-cta);
    outline-offset: 2px;
    border-radius: 6px;
  }

  .selected-style-tag {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    height: 23px;
    padding: 0 3px;
    border-radius: 5px;
    background: var(--selected-element-background);
    color: var(--selected-element-text);
    font-size: 12px;
    font-weight: 400;
  }
`;

export const ReadOnlyStyleEditorBody = styled.div`
  padding: 10px 10px 2px 10px;
  color: var(--grey-0);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;

  .ProseMirror {
    cursor: default;
  }
`;

export const StyleChooserContainer = styled.div`
  font-family: Inter;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: ${(props) => (props.$collapsed ? "0" : "0px 18px 18px 0px")};

  background: var(--simplified-sb-background);
  border-radius: 20px;

  header {
    padding: 6px 10px 7.5px 10px;
    margin-left: 0;
    border-radius: 10px 10px 0 0;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    font-weight: 500;
    font-size: 20px;
    color: var(--grey-0);
    min-width: 0;

    > span {
      min-width: 0;
      overflow: hidden;
    }

    .chevron-wrapper {
      display: flex;
      align-items: center;
      margin-left: -4px;
      margin-right: 6px;
    }

    .collapse-chevron {
      cursor: pointer;
      width: 20px;
      height: 20px;
      transition: transform 0.2s ease;

      path {
        fill: var(--grey-2);
      }
    }

    .rotated-chevron {
      transform: rotate(-90deg);
    }

    svg {
      width: 30px;
      height: 30px;
      flex: 0 0 auto;
      path {
        fill: var(--grey-0);
      }
      circle {
        fill: var(--grey-0);
      }
    }

    .style-heading-text {
      flex: 0 0 auto;
    }
  }

  .content {
    h3 {
      font-weight: 500;
      font-size: 16px;
      color: var(--grey-1);
      margin-bottom: 0.75em;
    }

    .content-wrapper {
      margin-top: 10px;
      display: flex;
      justify-content: left;

      .content {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        flex: 1;

        max-width: 900px;

        .action-btn {
          flex: 1;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 3px;

          height: 70px;
          /* max-width:  */

          /* padding: 14px; */
          border-radius: 12px;
          border: 1px solid var(--primary-cta-transparent);
          box-sizing: border-box;

          color: var(--primary-cta-high-contrast);
          font-size: 12px;
          text-align: center;

          font-weight: 500;

          &:hover {
            cursor: pointer;
            background-color: var(--primary-cta-transparent);
            background-clip: content-box;
          }

          .title {
            font-size: 16px;

            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 6px;

            svg {
              path {
                fill: var(--primary-cta-high-contrast);
              }
            }
          }
        }
      }
    }
  }
`;

export const MovedStylePointerContainer = styled.div`
  font-family: Inter;
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
  min-height: 98px;
  padding: 15px 25px 15px 22px;
  margin-bottom: 12px;
  box-sizing: border-box;
  border-radius: 6px;
  background: var(--menu-color-tinted, var(--menu-color));
  color: var(--grey-0);
  box-shadow: none;
  -webkit-font-smoothing: antialiased;
  text-rendering: geometricPrecision;

  .moved-style-icon {
    display: block;
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    margin-right: 24px;
    color: var(--primary-cta-high-contrast);

    path,
    circle {
      fill: currentColor;
    }
  }

  .moved-style-copy {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1 1 auto;
  }

  .moved-style-title-row {
    display: flex;
    align-items: center;
    gap: 9px;
    min-width: 0;
  }

  .moved-style-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    padding: 0 6px;
    margin-right: 24px;
    border-radius: 6px;
    background: var(--primary-cta-translucent);
    color: var(--primary-cta-high-contrast);
    font-size: 12px;
    font-weight: 600;
    line-height: 15.6px;
    letter-spacing: 0;
  }

  .moved-style-copy h3 {
    margin: 0 !important;
    color: var(--grey-0);
    font-size: 20px !important;
    font-weight: 500;
    line-height: 24.2045px !important;
    text-wrap: balance;
  }

  .moved-style-copy p {
    max-width: 438px;
    margin: 0 !important;
    color: var(--grey-1);
    font-size: 16px !important;
    font-weight: 400;
    line-height: 19.3636px !important;
    text-wrap: pretty;
  }

  .moved-style-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-width: 104px;
    height: 40px;
    flex: 0 0 auto;
    margin-left: 18px;
    padding: 0 16px;
    border: 0;
    border-radius: 8px;
    background: var(--primary-cta) !important;
    background-color: var(--primary-cta) !important;
    color: var(--cta-text-color);
    font: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    cursor: pointer;
    transition:
      transform 150ms ease,
      background-color 150ms ease,
      box-shadow 150ms ease;
    box-shadow: none;

    &:hover,
    &:focus-visible {
      background: var(--primary-cta-hover) !important;
      background-color: var(--primary-cta-hover) !important;
      outline: none;
      box-shadow: none;
    }

    &:active {
      transform: scale(0.96);
    }

    .moved-style-cta-icon {
      width: 24px;
      height: 24px;
    }

    .moved-style-cta-icon path {
      fill: currentColor;
    }
  }

  @media (max-width: 760px) {
    align-items: flex-start;
    flex-wrap: wrap;

    .moved-style-cta {
      margin-left: 0;
    }
  }
`;

export const FeaturedStyleWrapper = styled.div`
  justify-content: space-between;
  text-align: left;
  user-select: auto;
  display: flex;
  background: var(--menu-color);
  color: var(--grey-0);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  hr {
    border-top-width: 0;
    border-color: var(--menu-color-active);
    border-bottom-width: 1px;
    margin-bottom: 0;
  }

  .templates {
    width: 250px;
    padding: 10px 0;
    overflow-y: auto;
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
    flex: 0 0 auto;

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbar-track);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--scrollbar-thumb-hover);
    }

    h2 {
      padding: 5px 20px;
      font-size: 20px;
      font-weight: 600px;
      line-height: 24px;
    }

    ul {
      font-size: 16px;
      padding: 8px;

      li {
        margin: 8px;
        padding: 8px;
        cursor: pointer;
        border-radius: 6px;
        font-weight: 500;

        &:hover {
          cursor: pointer;
          background-color: var(--list-element-hover);
        }

        &.active {
          color: var(--selected-element-text);
          background: var(--selected-element-background);
        }
      }
    }
  }

  .template {
    border-left: 1px solid var(--menu-color-active);
    flex-grow: 1;
    padding: 20px;
    position: relative;

    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .description {
      flex: 1 1 auto;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      min-height: 0;

      header {
        display: flex;
        gap: 1.5rem;

        h3 {
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          flex: 1;
        }

        .close-btn {
          position: relative;
          top: -12px;
          right: -12px;
        }
      }

      .example {
        flex: 0 1 auto;
        font-size: 14px;
        white-space: pre-line;

        position: relative;
        min-height: 0;
        max-height: 310px;
        padding: 8px;
        padding-top: 0px;
        display: block;
        border-radius: 6px;
        border: 1px solid var(--grey-3);
        overflow-y: auto;
        scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

        &::-webkit-scrollbar {
          width: 8px;
        }
        &::-webkit-scrollbar-track {
          background: var(--scrollbar-track);
        }
        &::-webkit-scrollbar-thumb {
          background-color: var(--scrollbar-thumb);
          border-radius: 5px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background-color: var(--scrollbar-thumb-hover);
        }

        &::before {
          content: "Writing Sample";
          position: sticky;
          padding: 4px 0;
          padding-bottom: 6px;
          top: 0;
          left: 0;
          font-size: 12px;
          color: var(--grey-2);
          width: 100%;
          background: var(--menu-color);
          display: block;
        }
      }
    }

    .cta {
      flex: 1;
      display: flex;
      align-items: flex-end;
      justify-content: right;

      button.use-component-styles {
        z-index: 1;
        padding-left: 18px;
        padding-right: 18px;
        margin-right: -4px;
      }
    }
  }
`;
